import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const STORAGE_KEY = 'maestro_beta_toast_seen_v1';
const AUTO_DISMISS_MS = 12000;

/**
 * One-time per browser (localStorage). Skips /download marketing page until user navigates elsewhere.
 */
export default function BetaWelcomeToast() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);
  const scheduledRef = useRef(false);

  const dismiss = useCallback(() => {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {}
    setVisible(false);
  }, []);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) === '1') return;
    } catch {
      return;
    }
    if (scheduledRef.current) return;
    if (location.pathname === '/download') return;

    scheduledRef.current = true;
    setVisible(true);
  }, [location.pathname]);

  useEffect(() => {
    if (!visible) return;
    requestAnimationFrame(() => setMounted(true));
    const t = setTimeout(dismiss, AUTO_DISMISS_MS);
    return () => clearTimeout(t);
  }, [visible, dismiss]);

  if (!visible) return null;

  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        left: '50%',
        top: 72,
        transform: `translateX(-50%) translateY(${mounted ? 0 : -12}px)`,
        opacity: mounted ? 1 : 0,
        transition: 'opacity 0.35s ease, transform 0.35s ease',
        zIndex: 99989,
        maxWidth: 'min(520px, 92vw)',
        padding: '14px 40px 14px 18px',
        borderRadius: 14,
        background: '#1a1a2e',
        border: '1px solid rgba(201, 168, 76, 0.45)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.45), inset 0 1px 0 rgba(201,168,76,0.12)',
        pointerEvents: 'auto',
      }}
    >
      <button
        type="button"
        aria-label="Dismiss"
        onClick={dismiss}
        style={{
          position: 'absolute',
          top: 8,
          right: 10,
          width: 28,
          height: 28,
          border: 'none',
          borderRadius: 8,
          background: 'transparent',
          color: 'rgba(201, 168, 76, 0.85)',
          fontSize: 18,
          lineHeight: 1,
          cursor: 'pointer',
        }}
      >
        ×
      </button>
      <p
        style={{
          margin: 0,
          fontSize: 13,
          fontWeight: 500,
          lineHeight: 1.5,
          color: '#e8e4dc',
        }}
      >
        Welcome to Maestro Beta. Some features are still coming online — iOS and Android apps arrive June 2026.
        Found a bug or have feedback? Email{' '}
        <a href="mailto:paul@psaudio.com" style={{ color: '#C9A84C', textDecoration: 'underline' }}>
          paul@psaudio.com
        </a>{' '}
        — we read everything.
      </p>
    </div>
  );
}
